// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { addToEndOfChain, ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { chain as OrderDetailsReorder } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { chain as OrderHistoryReorder } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel } from "@insite/client-framework/Types/ApiModels";

type ReorderParameter = {
    orderNumber?: string;
};

type HandlerType = ApiHandlerDiscreteParameter<
    ReorderParameter,
    HasOnSuccess,
    CartLineCollectionModel,
    CartLineCollectionModel
>;

export const XngGaReorder: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentBillTo = getCurrentBillToState(state).value;
    const currentPage = getCurrentPage(state).type;
    const orderPageLink = getPageLinkByPageType(state, "OrderDetailsPage")?.url;
    const orderNumber = props.parameter?.orderNumber || state.pages.orderDetails.orderNumber;

    if (state.xGoogleAnalytics.includeReorderEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.REORDER,
            page_path: currentPage,
            destination: `${orderPageLink}?orderNumber=${orderNumber}`,
            affiliation: currentBillTo?.companyName,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
            order: orderNumber,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

const _GaReorder = XngGaReorder as any;
addToEndOfChain(OrderDetailsReorder, _GaReorder);
addToEndOfChain(OrderHistoryReorder, _GaReorder);
